document.addEventListener("wpcf7mailsent", function (event) {
  //   console.log(event);
  window.dataLayer.push({
    event: "cf7submission",
    location: window.location.pathname,
    formId: event.detail.contactFormId,
    response: event.detail.inputs,
  });
});

document.addEventListener("cc_userConsentSaved", function (event) {
  window.dataLayer.push({
    event: "cc_userConsentSaved",
    details: event?.details,
  });
});
